import { CheckboxProps, CheckboxGroupProps } from "react-aria-components";
import { ReactNode } from "react";

export enum MDSCheckboxSlotName {
  Before = "before",
  After = "after",
}

export interface MDSCheckboxProps extends CheckboxProps {
  /**
   * Children to render as the checkbox label.
   */
  children?: ReactNode;
}

export interface MDSCheckboxGroupProps extends Omit<CheckboxGroupProps, "children"> {
  /**
   * The label for the checkbox group.
   */
  label?: string;

  /**
   * The description for the checkbox group.
   */
  description?: string;

  /**
   * The error message for the checkbox group.
   */
  errorMessage?: string;

  /**
   * Children to render within the checkbox group.
   */
  children?: ReactNode;
}
